import { IcoEdit } from '@icons';
import React, { useState } from 'react';
import { Button, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';

export type ExecutionChecklistProjectType = {
	name: string;
	streamConfigurationType: string;
};

interface ExecutionChecklistCellRendererProps {
	value: {
		url: string;
	};
	project: ExecutionChecklistProjectType;
	data: Record<
		string,
		{
			key: string;
			hasDocuments: boolean;
		}
	>;
	modalComponent?: React.FC<{
		show: boolean;
		onHide: () => void;
		apiUrl: string;
		project: ExecutionChecklistProjectType;
	}>;
}

const ExecutionChecklistCellRenderer: React.FC<ExecutionChecklistCellRendererProps> = (params) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const ModalComponent = params.modalComponent;
	return (
		<>
			<Row className="align-items-center justify-content-between h-100 flex-nowrap">
				<Col className={'overflow-hidden d-flex justify-content-center'}>
					<OverlayTrigger placement="top" overlay={(props) => <Tooltip {...props}>Dettagli</Tooltip>}>
						<Button
							variant="link"
							className="d-flex align-items-start projectModalRenderBtn"
							style={{ color: '#1C2743', overflow: 'hidden' }}
							onClick={() => {
								setIsModalOpen(true);
							}}
						>
							<IcoEdit className="second-color path ico-small edit" />
						</Button>
					</OverlayTrigger>
				</Col>
			</Row>
			{ModalComponent ? (
				<ModalComponent
					show={isModalOpen}
					onHide={() => {
						setIsModalOpen(false);
					}}
					apiUrl={params.value.url}
					project={params.project}
				/>
			) : null}
		</>
	);
};

export default ExecutionChecklistCellRenderer;
